export const CONTACT_SUPPORT_EMAIL = "helpdesk@meplato.de";
export const CONTACT_FEEDBACK_EMAIL = "feedback@meplato.de";
export const PASSWORD_RESET_RETRY_WAITING_TIME_IN_SECONDS = 60;
